import { render, staticRenderFns } from "./PlayerIoDetailCard.vue?vue&type=template&id=5c1eaddd&"
import script from "./PlayerIoDetailCard.vue?vue&type=script&lang=js&"
export * from "./PlayerIoDetailCard.vue?vue&type=script&lang=js&"
import style0 from "./PlayerIoDetailCard.vue?vue&type=style&index=0&id=5c1eaddd&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports